function toError(reason) {
  return reason instanceof Error ? reason : new Error(String(reason));
}
const RetiredDriver = () => {
};
function runFrameInterpolation(scene, step, signal) {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(toError(signal.reason));
      return;
    }
    let settled = false;
    let onAbort;
    const finish = () => {
      if (settled) {
        return;
      }
      settled = true;
      const list = scene._beforeRender;
      const index = list.indexOf(driver);
      if (index >= 0) {
        list[index] = RetiredDriver;
        while (list.length > 0 && list[list.length - 1] === RetiredDriver) {
          list.pop();
        }
      }
      if (onAbort && signal) {
        signal.removeEventListener("abort", onAbort);
      }
    };
    const driver = (deltaMs) => {
      if (settled) {
        return;
      }
      const deltaSeconds = (deltaMs > 0 ? deltaMs : 1e3 / 60) / 1e3;
      let shouldContinue;
      try {
        shouldContinue = step(deltaSeconds);
      } catch (error) {
        finish();
        reject(toError(error));
        return;
      }
      if (!shouldContinue) {
        finish();
        resolve();
      }
    };
    if (signal) {
      onAbort = () => {
        finish();
        reject(toError(signal.reason));
      };
      signal.addEventListener("abort", onAbort);
    }
    scene._beforeRender.push(driver);
  });
}

export { runFrameInterpolation };
//# sourceMappingURL=frame-interpolation.js.map
